import React, { useContext } from "react";

import SectionCard from "../../../profiles/SectionCard";
import MessageButton from "../../../MessageButton";
import { ProductContext } from "../../data/product_context_management";

// V1's sample request was never a workflow — it was a message template into normal messaging, so
// this is the ordinary composer opened with the request already written. It mounts its own instance
// rather than reusing the Connect card's: that one is the plain "Message" affordance and can't
// carry a different label and prefill.
const REQUEST_SAMPLE_BODY = `Hi!

I'm writing an article and your product may be suitable for inclusion.

Could you please send me a sample so I can try it out?

Thanks!`;

// The rail's samples card. Availability is the whole gate — a product that isn't offering samples
// gets no card, so the request affordance can only appear where there is something to request.
function SamplesCard() {
  const { product, canRequestSample } = useContext(ProductContext);

  return (
    <SectionCard id="product-rail-samples" title="Samples">
      <div className="mb-2">
        <span className="badge rounded-pill bg-success-subtle text-success-emphasis border border-success-subtle">
          Available
        </span>
      </div>

      {canRequestSample && (
        <MessageButton
          promoEntityId={product.id}
          promoEntityType="Id::PromoEntity::Product"
          extraButtonClasses="w-100 mt-2"
          buttonLabel="Request sample"
          buttonIconClasses="fa-solid fa-hand-paper"
          initialSubject={`PRODUCT SAMPLE REQUEST | For ${product.name}`}
          initialBody={REQUEST_SAMPLE_BODY}
        />
      )}
    </SectionCard>
  );
}

export default SamplesCard;
